import { RegistryIdentityNameKind } from '@navio/nsdk';
import { useRegistryIdentityNameOptions } from './useRegistryIdentityNameFilter';

/** Title, description and visible options of this filter, for the builder next to its options. */
export const CAR_MAKE_FILTER_TEXT = {
  title: 'Car makes',
  description: 'Filter by specific car makes',
  defaultVisibleOptions: 5
};

/** Registry car makes as filter options (first 200), searchable. For `unit.multiSelect`. */
export const useCarMakeNameOptions = () => useRegistryIdentityNameOptions(RegistryIdentityNameKind.MAKE);
